import { ICrudLocale } from '@app/i18n/interface';

export const GROUP_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  GROUP: {
    LABEL: {
      SINGULAR: 'Grupo',
      PLURAL: 'Grupos',
    },
    FORM: {
      ADD_TITLE: 'Añadir grupo',
      EDIT_TITLE: 'Editar grupo',
      CARD_TITLE: 'Datos del grupo',
      BACK: 'Volver a Grupos',
      ADD_DESCRIPTION: 'Crea un grupo y elige sus roles; quien esté en él tendrá esos permisos.',
      EDIT_DESCRIPTION: 'Cambia el nombre, los roles o el estado del grupo.',
    },
    FIELD: {
      NAME: 'Grupo',
      ACTIVE: 'Activo',
      ROLES: 'Roles',
      USERS: 'Usuarios',
      STATE: 'Estado',
    },
    LIST: {
      DESCRIPTION: 'Cada usuario pertenece a un grupo, y el grupo decide qué puede hacer.',
      ADD: 'Añadir grupo',
      TITLE: 'Grupos del back office',
      CAPTION: 'Grupos, sus roles y cuántos usuarios tienen',
      EMPTY: 'Todavía no hay grupos.',
      USERS_ONE: '1 usuario',
      USERS: '{{count}} usuarios',
      ACTIVE: 'Activo',
      INACTIVE: 'Desactivado',
      EDIT: 'Editar',
      EDIT_ARIA: 'Editar el grupo {{name}}',
      DISABLE: 'Desactivar',
      DISABLE_ARIA: 'Desactivar el grupo {{name}}',
      ENABLE: 'Reactivar',
      ENABLE_ARIA: 'Reactivar el grupo {{name}}',
      DELETE: 'Eliminar',
      DELETE_ARIA: 'Eliminar el grupo {{name}}',
      VIEW_USERS: 'Ver usuarios',
      TOGGLE_ERROR: 'No hemos podido cambiar el estado del grupo. Vuelve a intentarlo.',
    },
    DISABLE: {
      TITLE: '¿Desactivar el grupo {{name}}?',
      BODY: 'Sus {{count}} usuarios dejarán de tener los permisos de este grupo hasta que lo reactives.',
      KEEP: 'Mantener activo',
      CONFIRM: 'Desactivar grupo',
    },
    DELETE: {
      TITLE: '¿Eliminar el grupo {{name}}?',
      BODY: 'El grupo se borra y no se puede deshacer desde aquí.',
      USERS: 'Tiene {{count}} usuarios: perderán los permisos de este grupo.',
      KEEP: 'Mantener el grupo',
      CONFIRM: 'Eliminar grupo',
      DONE: 'El grupo {{name}} se ha eliminado.',
      ERROR: 'No hemos podido eliminar el grupo {{name}}. Vuelve a intentarlo.',
    },
    PROPOSAL: {
      TITLE: 'Permisos por grupo',
      BADGE: 'Propuesta pendiente de confirmar',
      NOTE: 'Esta tabla es una propuesta para revisar y todavía no cambia nada: hoy cada grupo tiene los permisos de sus roles (Administrador o Usuario). Los permisos marcados como destructivos cancelan reservas, devuelven dinero, borran datos o cambian precios. Administrador conserva siempre todos los permisos, para que nunca te quedes sin acceso.',
      CAPTION: 'Propuesta de permisos de cada grupo, agrupados por área',
      PERMISSION_COL: 'Permiso',
      YES: 'Sí',
      NO: 'No',
      DESTRUCTIVE: 'Destructivo',
      GROUP: {
        ADMIN: 'Administrador',
        OPERATIONS: 'Operaciones',
        SUPPORT: 'Atención al cliente',
        READ_ONLY: 'Solo lectura',
      },
      AREA: {
        BOOKINGS: 'Reservas',
        CANCELLATIONS: 'Cancelaciones',
        CUSTOMERS: 'Clientes',
        MARKUPS: 'Márgenes',
        CATALOG: 'Catálogo',
        USERS: 'Usuarios',
        PROVIDER_CALLS: 'Llamadas a Hotelbeds',
      },
      PERMISSION: {
        VIEW_BOOKINGS: 'Ver reservas',
        VIEW_BOOKINGS_D: 'Lista y detalle de cada reserva',
        RESEND_VOUCHER: 'Reenviar el voucher',
        RESEND_VOUCHER_D: 'Envía de nuevo el voucher al cliente',
        CHECK_STATUS: 'Comprobar el estado en Hotelbeds',
        CHECK_STATUS_D: 'Consulta el estado de una reserva en Hotelbeds',
        CANCEL_BOOKINGS: 'Cancelar reservas',
        CANCEL_BOOKINGS_D: 'Cancela en Hotelbeds y aplica la política de cancelación',
        REFUND: 'Reembolsar al cliente',
        REFUND_D: 'Devuelve dinero por Stripe',
        VIEW_CUSTOMERS: 'Ver clientes',
        VIEW_CUSTOMERS_D: 'Lista de clientes y sus datos',
        EXPORT_CUSTOMERS: 'Exportar clientes a CSV',
        EXPORT_CUSTOMERS_D: 'Descarga datos personales',
        DELETE_CUSTOMERS: 'Eliminar clientes',
        DELETE_CUSTOMERS_D: 'Borra la cuenta de un cliente',
        VIEW_MARKUPS: 'Ver márgenes',
        VIEW_MARKUPS_D: 'Márgenes, RSP y tipo de cambio',
        EDIT_MARKUPS: 'Editar márgenes',
        EDIT_MARKUPS_D: 'Cambia el precio de venta de las tarifas',
        VIEW_CATALOG: 'Ver el catálogo',
        VIEW_CATALOG_D: 'Hoteles, destinos y estado de la sincronización',
        RUN_SYNC: 'Ejecutar la sincronización ahora',
        RUN_SYNC_D: 'Lanza una sincronización de contenido',
        VIEW_USERS: 'Ver usuarios y grupos',
        VIEW_USERS_D: 'Lista del equipo y permisos',
        EDIT_USERS: 'Añadir y editar usuarios',
        EDIT_USERS_D: 'Da de alta a alguien o cambia su grupo',
        DISABLE_USERS: 'Desactivar usuarios',
        DISABLE_USERS_D: 'Cierra el acceso de una persona',
        DELETE_USERS: 'Eliminar usuarios',
        DELETE_USERS_D: 'Borra la cuenta de una persona',
        VIEW_CALLS: 'Ver el registro de llamadas',
        VIEW_CALLS_D: 'Hora, operación y estado de cada llamada',
        VIEW_RAW_CALLS: 'Ver peticiones y respuestas completas',
        VIEW_RAW_CALLS_D: 'Contenido íntegro enviado y recibido',
      },
    },
  },
};
